import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSuccessCheckmark = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19.9991 10.0004C19.9991 15.5229 15.5223 19.9998 9.99955 19.9998C4.47684 19.9998 -3.83387e-05 15.5229 -3.83387e-05 10.0004C-3.83387e-05 4.47757 4.47684 0.000623003 9.99955 0.000623003C15.5223 0.000623003 19.9991 4.47757 19.9991 10.0004Z",
			fill: "url(#paint0_linear_2641_120537)"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_2641_120537",
			maskUnits: "userSpaceOnUse",
			x: 4,
			y: 4,
			width: 12,
			height: 12,
			children: /* @__PURE__ */ _jsx("rect", {
				x: 4,
				y: 4,
				width: 12,
				height: 12,
				fill: "#69EFBF"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_2641_120537)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M14.7852 6.22244C14.6565 6.07977 14.4843 6 14.3052 6C14.126 6 13.9538 6.07977 13.8251 6.22244L8.55456 12.1406L6.16431 9.43337C6.03476 9.29033 5.86177 9.2104 5.68176 9.2104C5.50176 9.2104 5.32877 9.29033 5.19921 9.43337C5.13616 9.50375 5.08605 9.58786 5.05184 9.68076C5.01763 9.77365 5 9.87344 5 9.97424C5 10.0751 5.01763 10.1748 5.05184 10.2677C5.08605 10.3606 5.13616 10.4447 5.19921 10.5151L8.07451 13.7776C8.20323 13.9202 8.37538 14 8.55456 14C8.73374 14 8.90589 13.9202 9.03461 13.7776L14.7852 7.33281C14.8529 7.26253 14.9069 7.17683 14.9439 7.08122C14.9809 6.98561 15 6.88219 15 6.77763C15 6.67306 14.9809 6.56965 14.9439 6.47403C14.9069 6.37842 14.8529 6.29272 14.7852 6.22244Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_2641_120537",
			x1: 10,
			y1: 0,
			x2: 10,
			y2: 20,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#69EFBF" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#37B99A"
			})]
		}) })
	]
});
const ForwardRef = forwardRef(SvgSuccessCheckmark);
export default ForwardRef;
